import { FundriseRouteConfig } from 'vue-router';

const sanityPreviewRoutes: FundriseRouteConfig[] = [
	{
		path: `/preview/`,
		name: 'sanity-preview',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED', isSanityPreview: true },
		children: [
			// {
			// 	path: 'education',
			// 	meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
			// name: 'blog-landing-preview',
			// 	component: () => import('@views/blog/landing-view.vue')
			// },
			{
				path: 'education/:blogPostUrlSlug',
				meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
				name: 'blog-post-preview',
				component: () => import('@views/blog/article-view.vue')
			}
		]
	}
];

export default sanityPreviewRoutes;
